import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { withNamespaces } from "react-i18next";
import { withHeaderTitle } from "../../components/Header/HeaderTitle";
// componentes de terceros.
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
// componentes.
import CalidadVidaScreen from "./dashboardTabs/CalidadVidaScreen";
import ProblemasScreen from "./dashboardTabs/ProblemasScreen";
import IngresosScreen from "./dashboardTabs/IngresosScreen";
import MutualSegurosScreen from "./dashboardTabs/MutualSegurosScreen";
import DashboardForm from "./DashboardForm";
// funciones
import { makeStyles } from "@material-ui/core";
import useWindowDimensions from "../../hooks/useWindowsDimencions";

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    width: "100%",
  },
}));

const DashboardTabs = (props) => {
  props.setHeaderTitle("Dashboard");
  const classes = useStyles();
  const { width } = useWindowDimensions();
  const [filters, setFilters] = useState({
    medicion: [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025"
    ],
  });
  const [onSearch, setOnSearch] = useState(false);
  const [variantTab, setVariantTab] = useState('fullWidth');

  const lastIndex = parseInt(localStorage.getItem("last-index")) || 0;
  const [selectedTab, setSelectedTab] = useState(lastIndex);
  const handleChangeTab = (event, value) => {
    localStorage.setItem("last-index", value);
    setSelectedTab(value);
  };

  const defineVariantTab = () => {
    if(width < 600){
      setVariantTab('scrollable');
    }else{
      setVariantTab('fullWidth');
    }
  }

  useEffect(() => {
    defineVariantTab();
  }, [width])

  return (
    <div className={classes.root}>
      <AppBar position="static" color="default">
        <Tabs
          value={selectedTab}
          onChange={handleChangeTab}
          indicatorColor="primary"
          textColor="primary"
          variant={variantTab}
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
        >
          <Tab label="Problemas, sueños y temores" {...a11yProps(0)} />
          <Tab label="Calidad de vida" {...a11yProps(1)} />
          <Tab label="Ingresos y problemas económicos" {...a11yProps(2)} />
          <Tab label="Ahorro" {...a11yProps(3)} />
        </Tabs>
      </AppBar>

      <div className="container-fluid pb-0">
        <DashboardForm setOnSearch={setOnSearch} updateFilters={setFilters} />
      </div>

      <TabPanel value={selectedTab} index={0}>
        <ProblemasScreen
          filters={filters}
          onSearch={onSearch}
          setOnSearch={setOnSearch}
        />
      </TabPanel>
      <TabPanel value={selectedTab} index={1}>
        <CalidadVidaScreen 
          filters={filters}
          onSearch={onSearch}
          setOnSearch={setOnSearch}
        />
      </TabPanel>
      <TabPanel value={selectedTab} index={2}>
        <IngresosScreen
          filters={filters}
          onSearch={onSearch}
          setOnSearch={setOnSearch}
        />
      </TabPanel>
      <TabPanel value={selectedTab} index={3}>
        <MutualSegurosScreen
          filters={filters}
          onSearch={onSearch}
          setOnSearch={setOnSearch}
        />
      </TabPanel>
    </div>
  );
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <Box className="pt-0 mt-0" p={3}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

export default withNamespaces("translations")(withHeaderTitle(DashboardTabs));
